const _require = require('./styled-breakpoints'),
  createStyledBreakpoints = _require.createStyledBreakpoints;
exports.createStyledBreakpoints = createStyledBreakpoints;